import { ApiBalanceHistoryEvent } from 'api/types';

import { convertApiBridge } from '../bridge/crossChainMapping';

export const detectTransactionBridge = (
  transaction: ApiBalanceHistoryEvent
): 'Stargate' | undefined =>
  transaction.type === 'pendingDeposit'
    ? transaction.bridge
    : transaction.type === 'withdrawal'
    ? convertApiBridge(transaction.bridgeTarget).bridge
    : transaction.type === 'deposit'
    ? convertApiBridge(transaction.bridgeSource).bridge
    : undefined;
